import { render, staticRenderFns } from "./LeadXpressTranslate.vue?vue&type=template&id=10cc02f9&"
import script from "./LeadXpressTranslate.vue?vue&type=script&lang=js&"
export * from "./LeadXpressTranslate.vue?vue&type=script&lang=js&"
import style0 from "./LeadXpressTranslate.vue?vue&type=style&index=0&id=10cc02f9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports